<header class="row">
  @if (picture !== null && picture !== undefined) {
    <div class="circle">
      <div class="picture">
        <img [ngSrc]="(picture | employeePictureUrl)" alt="Pic" priority fill/>
      </div>
    </div>
  }

  <div class="title">{{ name }}</div>
  @if (saveEnabled) {
    <div
      class="btn-area"
      [confirmMessage]="saveConfirm.confirmMessage"
      [titleMessage]="saveConfirm.titleMessage"
      (confirm)="onClick.emit()"
    >
      <app-form-btn
        [css]="'small-save-btn'"
        [icon]="'fa-regular fa-save'"
        [loading]="loading"
      >
      </app-form-btn>
    </div>
  }
</header>
